if (typeof L !== 'undefined') {
    require('./torque');
}



//////////////////
// WEBPACK FOOTER
// ./~/torque.js/lib/torque/leaflet/index.js
// module id = 1651
// module chunks = 6